import React from 'react';
import { Alert } from 'react-bootstrap';
import { Pb3 } from '../../../components/P';
import { Button, Result } from 'antd';
import { useGet } from '../../../hooks/useApi';

interface ContractData {
  studentId: number;
  studentName: string;
  documentId: string;
  slug: string;
  completed: boolean;
}

const PendingContractsAlert = () => {
  const getContractSlugs = useGet<ContractData[]>(
    `/v1/auth/reg/register-schedule/contract-slugs`
  );

  // If there's an error, still loading, or no pending contracts, don't render anything
  if (
    getContractSlugs.isLoading ||
    getContractSlugs.isError ||
    !getContractSlugs.data ||
    !getContractSlugs.data.some((contract) => !contract.completed)
  ) {
    return null;
  }

  // Count pending contracts
  const pendingCount = getContractSlugs.data.filter(
    (contract) => !contract.completed
  ).length;

  const handleSignNow = () => {
    // Navigate to dedicated contracts signing page
    window.location.href = '/contracts';
  };

  return (
    <Pb3>
      <Alert style={{ padding: 0 }} variant="warning">
        <Result
          status="warning"
          title={`You have ${pendingCount} pending contract${
            pendingCount !== 1 ? 's' : ''
          } to sign`}
          subTitle="Please sign your contracts to complete the registration process."
          extra={[
            <Button type="primary" onClick={handleSignNow} key="sign">
              Sign Now
            </Button>,
          ]}
        />
      </Alert>
    </Pb3>
  );
};

export default PendingContractsAlert;
